// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"61":"622ff532","103":"118ed3ce","664":"0c342d6a","695":"5c959531","808":"c6ffaf56"}[chunkId] + ".chunk.js";
};